import clone from 'fast-copy';
import { SupportTicketPaymentMapper } from '../SupportTicketPayment/SupportTicketPaymentMapper.js';
import { SupportTicketAttachmentDetailsMapper } from '../SupportTicketAttachmentDetails/SupportTicketAttachmentDetailsMapper.js';

class SupportTicketClaimDataMapper {
  static createModelFromResponse(response) {
    return {
      amount: clone(response.amount),
      proofOfValue: response.proof_of_value,
      proofOfValueAttachmentDetail: SupportTicketAttachmentDetailsMapper.createModelFromResponse(response.proof_of_value_attachment_detail),
      productDescription: response.product_description,
      paymentMethod: SupportTicketPaymentMapper.createModelFromResponse(response.payment_method)
    };
  }
  static createApiPayload(_ref) {
    let {
      amount,
      proofOfValue,
      productDescription,
      paymentMethod
    } = _ref;
    return {
      amount: clone(amount),
      proof_of_value: proofOfValue,
      product_description: productDescription,
      payment_method: SupportTicketPaymentMapper.createApiPayload(paymentMethod)
    };
  }
}

export { SupportTicketClaimDataMapper };
//# sourceMappingURL=SupportTicketClaimDataMapper.js.map
